// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ta-profile {
  cursor: pointer;
  margin-right: 20px;
}
.ta-profile-parent {
  display: flex;
  justify-content: center;
  padding-right: 2px;
  padding-left: 2px;
  height: 100%;
}

.profile-dd-items {
  display: table;
  list-style: none;
  padding: 0px;
  background: white;
  /* color: #007bff; */
  color: black;
  border: 1px solid rgba(88, 89, 91, 1);
  border-top: 10px solid rgba(0, 126, 167, 1);
  z-index: 1;
  width: 300px;
  padding: 5px;
  position: fixed;
  top: 34px;
  right: 21px;
  cursor: default;
}
.profile-dd-item {
  cursor: pointer;
  text-align: right;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  color: rgba(0, 126, 167, 1);
}
.profile-dd-item:hover {
  color: rgba(0, 126, 167, 1);
  text-decoration: underline;
  text-decoration-color: rgba(0, 126, 167, 1);
  background-color: #cfeaf8;
}
.profile-user-name {
  display: flex;
  border-bottom: 1px solid rgba(88, 89, 91, 1);
  cursor: default;
  margin-bottom: 6px;
}

.profile-selected:hover {
  fill: white;
}

.profile-parent-selected {
  background-color: rgba(0, 126, 167, 1);
}

.profile-selected {
  cursor: pointer;
  align-items: center;
  width: 20px;
  height: 28px;
  display: flex;
  background: rgba(0, 126, 167, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/profile/style/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC","sourcesContent":[".ta-profile {\n  cursor: pointer;\n  margin-right: 20px;\n}\n.ta-profile-parent {\n  display: flex;\n  justify-content: center;\n  padding-right: 2px;\n  padding-left: 2px;\n  height: 100%;\n}\n\n.profile-dd-items {\n  display: table;\n  list-style: none;\n  padding: 0px;\n  background: white;\n  /* color: #007bff; */\n  color: black;\n  border: 1px solid rgba(88, 89, 91, 1);\n  border-top: 10px solid rgba(0, 126, 167, 1);\n  z-index: 1;\n  width: 300px;\n  padding: 5px;\n  position: fixed;\n  top: 34px;\n  right: 21px;\n  cursor: default;\n}\n.profile-dd-item {\n  cursor: pointer;\n  text-align: right;\n  padding-right: 10px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  color: rgba(0, 126, 167, 1);\n}\n.profile-dd-item:hover {\n  color: rgba(0, 126, 167, 1);\n  text-decoration: underline;\n  text-decoration-color: rgba(0, 126, 167, 1);\n  background-color: #cfeaf8;\n}\n.profile-user-name {\n  display: flex;\n  border-bottom: 1px solid rgba(88, 89, 91, 1);\n  cursor: default;\n  margin-bottom: 6px;\n}\n\n.profile-selected:hover {\n  fill: white;\n}\n\n.profile-parent-selected {\n  background-color: rgba(0, 126, 167, 1);\n}\n\n.profile-selected {\n  cursor: pointer;\n  align-items: center;\n  width: 20px;\n  height: 28px;\n  display: flex;\n  background: rgba(0, 126, 167, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
